var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.266667,
    y: 0.266667,
    width: 31.4667,
    height: 31.4667,
    rx: 7.73333,
    stroke: "#6B6084",
    strokeWidth: 0.533333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.032 22.4092C19.0696 22.4092 22.372 17.4841 22.372 13.2135C22.372 13.0733 22.372 12.9342 22.3624 12.7955C23.0048 12.3387 23.5592 11.7715 24 11.1225C23.4016 11.384 22.7656 11.5555 22.1152 11.6311C22.8 11.227 23.3128 10.5922 23.5584 9.8432C22.9136 10.2197 22.2088 10.4854 21.4736 10.628C20.2304 9.32678 18.1512 9.26374 16.8288 10.4877C15.9768 11.2769 15.6144 12.4536 15.8792 13.576C13.24 13.4453 10.7808 12.2181 9.1136 10.1994C8.2424 11.6763 8.688 13.5648 10.1304 14.5131C9.608 14.4981 9.0968 14.3597 8.64 14.1092V14.1502C8.6408 15.6885 9.7424 17.013 11.2736 17.3178C10.7904 17.4478 10.2832 17.4666 9.792 17.3729C10.2216 18.6898 11.4544 19.5918 12.8584 19.6178C11.696 20.5173 10.26 21.0057 8.7816 21.0041C8.5208 21.0033 8.26 20.9884 8 20.9576C9.5016 21.906 11.248 22.4092 13.032 22.4069",
    fill: "#6B6084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/TwitterIcon.23f11bb4e79ff367c52c21e71eab1f59.svg";
export { ForwardRef as ReactComponent };